// reducers/whatsappReducer.js

import { LOAD_WHATSAPP_MESSAGES } from "../actions/actionTypes";

const initialState = {
    messages: [],
};

export const whatsappReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_WHATSAPP_MESSAGES:
            return {
                ...state,
                messages: action.messages
            };
        // Adicione outros cases conforme necessário para outras ações do WhatsApp

        default:
            return state;
    }
};
